import Vue from 'vue'

import App from './App.vue'
import router from './router'

import Select2 from 'v-select2-component';

window.$ = require('jquery')
window.JQuery = require('jquery')

import(/* webpackPrefetch: true */ './assets/js/pages.js')

Vue.config.productionTip = false

Vue.component('select2', Select2);

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')
